import dynamic from 'next/dynamic';

import webStorageKeys from '@/constants/web-storage-keys';
import { useLocalStorage } from '@nf/utils-common/hooks';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';

import { GoldenDuelPromoModal } from '../golden-duel-promo-modal';
import { GoldenDuelRulesPopup } from '../rules-popup/golden-duel-rules-popup';

const GoldenDuelAwardModal = dynamic(
	() => import('@/features/promotion/golden-duel/golden-duel-award-modal').then(mod => mod.GoldenDuelAwardModal),
	{ ssr: false }
);

export const GoldenDuelModalContainer = () => {
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const [isGoldenDuelPromoTriggered] = useLocalStorage(webStorageKeys.GOLDEN_DUEL_PROMO_TRIGGERED, false);

	const shouldShowPromoModal = user && 
		SiteConfigsData?.EnableGoldenDuelPopup && 
		!isGoldenDuelPromoTriggered;

	return (
		<>
			{shouldShowPromoModal ? <GoldenDuelPromoModal /> : null}
			{SiteConfigsData?.EnableGoldenDuel ? <GoldenDuelAwardModal /> : null}
			<GoldenDuelRulesPopup />
		</>
	);
};